<div class="row" *ngIf="service && service.serviceJsonProperties">
  <div class="col-12 col-md-12 pt-0 pl-4 pr-4">
    <div class="form-group">
      <div class="row">
        <div class="col-12">
          <label class="input-label">{{'Cache' | translate}}</label>
          <div class="table-items">
            <div class="item">
              <div class="row cursor-row" (click)="
              service.serviceJsonProperties.cacheEnabled = !service
                .serviceJsonProperties.cacheEnabled; autoSave(pages);">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="showOnlyRegistrationFields" class="fas {{
                  service.serviceJsonProperties &&
                  service.serviceJsonProperties.cacheEnabled
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{'Enable cache for faster UI experience' | translate}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group" *ngIf="!service.isMyAccountPage">
      <div class="row">
        <div class="col-12">
          <label class="input-label">{{
            'Blocks and Fields' | translate
          }}</label>
          <div class="table-items">
            <!--
            <div class="item">
              <div class="row cursor-row" (click)="
              service.serviceJsonProperties.showOnlyRegistrationFields = !service
                .serviceJsonProperties
                .showOnlyRegistrationFields; autoSave(pages);
            ">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="showOnlyRegistrationFields" class="fas {{
                  service.serviceJsonProperties &&
                  service.serviceJsonProperties
                    .showOnlyRegistrationFields
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{
                  'Blocks/fields visible only if linked to registration' | translate
                  }}</label>
                </div>
              </div>
            </div>
          -->
            <div class="item">
              <div class="row cursor-row" (click)="
              service.serviceJsonProperties.showOnlyRegistrationFieldsPartB = !service
                .serviceJsonProperties
                .showOnlyRegistrationFieldsPartB; autoSave(pages);
            ">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="showOnlyRegistrationFieldsPartB" class="fas {{
                  service.serviceJsonProperties &&
                  service.serviceJsonProperties
                    .showOnlyRegistrationFieldsPartB
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{
                    'Part B Blocks/fields visible only if linked to registration' | translate
                    }}</label>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="row cursor-row" (click)="
              service.serviceJsonProperties.blocksCollapsibleInBpa = !service
                .serviceJsonProperties
                .blocksCollapsibleInBpa; autoSave(pages);
            ">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="blocksCollapsibleInBpa" class="fas {{
                  service.serviceJsonProperties &&
                  service.serviceJsonProperties
                    .blocksCollapsibleInBpa
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{
                    'Blocks collapsible in BPA' | translate
                    }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group" *ngIf="service && !service.isMyAccountPage && service.serviceJsonProperties && service.id">
      <div class="row">
        <div class="col-12">
          <label class="input-label">{{
            'Buttons' | translate
          }}</label>
          <div class="table-items">
            <div class="item">
              <div class="row cursor-row" (click)="
              service.serviceJsonProperties.showPrintButtonOnGuide = !service
                .serviceJsonProperties
                .showPrintButtonOnGuide; autoSave(pages);
            ">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="showPrintButtonOnGuide" class="fas {{
                    service.serviceJsonProperties &&
                    service.serviceJsonProperties
                      .showPrintButtonOnGuide
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{
                    'Show print button on guide' | translate
                    }}</label>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="row cursor-row" (click)="
              service.serviceJsonProperties.showPrintButtonInPartB = !service
                .serviceJsonProperties
                .showPrintButtonInPartB; autoSave(pages);
            ">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="showPrintButtonInPartB" class="fas {{
                    service.serviceJsonProperties &&
                    service.serviceJsonProperties
                      .showPrintButtonInPartB
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{
                    'Show print button in Part B' | translate
                    }}</label>
                </div>
              </div>
            </div>
            <div class="item" *ngIf="service.serviceJsonProperties.showPrintButtonInPartB">
              <div class="row">
                <div class="col-12">
                  <label>{{ 'Print action' | translate }}</label>
                  <select
                    [(ngModel)]="service.serviceJsonProperties.partBprintAction"
                    (change)="onChange($event, pages)"
                    class="form-control">
                    <option *ngFor="let bot of bots" [ngValue]="bot.id">{{bot.name}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="form-group" *ngIf="!service.isMyAccountPage">
      <div class="row">
        <div class="col-12">
          <label class="input-label">{{
            'Page' | translate
          }}</label>

          <div class="table-items">
            <div class="item">
              <div class="row cursor-row" (click)="
              service.serviceJsonProperties.showPageName = !service
                .serviceJsonProperties
                .showPageName; autoSave(pages);
            ">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="showPageName" class="fas {{
                    service.serviceJsonProperties &&
                    service.serviceJsonProperties
                      .showPageName
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{
                    'Show the page name' | translate
                    }}</label>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="row cursor-row" (click)="
              service.serviceJsonProperties.useFilePreviewComponent = !service
                .serviceJsonProperties
                .useFilePreviewComponent; autoSave(pages);
            ">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="useFilePreviewComponent" class="fas {{
                    service.serviceJsonProperties &&
                    service.serviceJsonProperties
                      .useFilePreviewComponent
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{
                    'Use file with preview' | translate
                    }}</label>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="row cursor-row">
                <div class="col-12">
                  <label>{{
                    'Type of files in requirements page' | translate
                    }}
                    <i class="fas fa-info-circle label-info-tooltip" tooltip="{{ 'service.settings_page_requirements_filetypes_tooltip' | translate }}"></i>
                  </label>
                  <input
                          class="form-control"
                          type="text"
                          name="name"
                          [(ngModel)]="service.serviceJsonProperties.requirementsFilePattern"
                          [rangeLength]="[2, 256]"
                          (focusout)="autoSave(pages)"
                  />
                </div>
              </div>
            </div>
            <div class="item">
              <div class="row cursor-row" (click)="service.serviceJsonProperties.validateRoleFields = !service
              .serviceJsonProperties.validateRoleFields; autoSave(pages);">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="validateRoleFields" class="fas {{
                    service.serviceJsonProperties &&
                    service.serviceJsonProperties.validateRoleFields
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{ 'Revision by field' | translate }}</label>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="row cursor-row" (click)="service.serviceJsonProperties.showDecimalsForCosts = !service
              .serviceJsonProperties.showDecimalsForCosts; autoSave(pages);">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="showDecimalsForCosts" class="fas {{
                    service.serviceJsonProperties &&
                    service.serviceJsonProperties.showDecimalsForCosts
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{ 'Show decimals for costs' | translate }}</label>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="row cursor-row" (click)="service.serviceJsonProperties.showDataFirstInPartBRoleForm = !service
              .serviceJsonProperties.showDataFirstInPartBRoleForm; autoSave(pages);">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="showDataFirstInPartBRoleForm" class="fas {{
                    service.serviceJsonProperties &&
                    service.serviceJsonProperties.showDataFirstInPartBRoleForm
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>
                    {{ 'Data tab first on partb processing role form' | translate }}
                    <i class="fas fa-info-circle label-info-tooltip" tooltip="{{ 'By default data tab is last on partb processing role form' | translate }}"></i>
                  </label>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="form-group" *ngIf="!service.isMyAccountPage">
      <div class="row">
        <div class="col-12">
          <label class="input-label">{{
            'Application history' | translate
          }}</label>

          <div class="table-items">
            <div class="item">
              <div class="row cursor-row" (click)="
              service.serviceJsonProperties.showApplicationHistory = !service
                .serviceJsonProperties
                .showApplicationHistory; autoSave(pages);
            ">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="showApplicationHistory" class="fas {{
                    service.serviceJsonProperties &&
                    service.serviceJsonProperties
                      .showApplicationHistory
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{
                    'Show application history' | translate
                    }}</label>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="form-group" *ngIf="guideTypesOptions && !service.isMyAccountPage">
      <div class="row">
        <div class="col-12">
          <label class="input-label">{{
            'Guide configuration' | translate
          }}</label>

          <div class="table-items">
            <div class="item">
              <div class="row">
                <div class="col-12">
                  <select
                    [(ngModel)]="service.serviceJsonProperties.guideType"
                    (change)="onChange($event, pages); updateGuideType();"
                    class="form-control">
                    <option *ngFor="let type of guideTypesOptions" [ngValue]="type">{{guideTypesEnum[type] | translate}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="table-items mt-1" *ngIf="service.serviceJsonProperties && service.serviceJsonProperties.guideType !== guideTypesOptions[2]">
            <div class="item">
              <div class="row cursor-row" (click)="
              service.serviceJsonProperties.hideCostIfMissing = !service
                .serviceJsonProperties.hideCostIfMissing; autoSave(guide);
            ">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="hideCostIfMissing" class="fas {{
                    service.serviceJsonProperties &&
                    service.serviceJsonProperties.hideCostIfMissing
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{
                    'Hide costs if missing' | translate
                    }}</label>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="row cursor-row" (click)="
              service.serviceJsonProperties.showGuideInitialDescription = !service
                .serviceJsonProperties.showGuideInitialDescription; autoSave(guide);
            ">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="showGuideInitialDescription" class="fas {{
                    service.serviceJsonProperties &&
                    service.serviceJsonProperties.showGuideInitialDescription
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{
                    'Show Initial question description text' | translate
                  }}</label>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="row cursor-row" (click)="
              service.serviceJsonProperties.showGuideMandatoryRegistrationsDescription = !service
                .serviceJsonProperties
                .showGuideMandatoryRegistrationsDescription; autoSave(guide);
            ">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="showGuideMandatoryRegistrationsDescription" class="fas {{
                    service.serviceJsonProperties &&
                    service.serviceJsonProperties
                      .showGuideMandatoryRegistrationsDescription
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{
                    'Show Mandatory registrations description text' | translate
                  }}</label>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="row cursor-row" (click)="
              service.serviceJsonProperties.showGuideOptionalRegistrationsDescription = !service
                .serviceJsonProperties
                .showGuideOptionalRegistrationsDescription; autoSave(guide);
            ">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="showGuideOptionalRegistrationsDescription" class="fas {{
                    service.serviceJsonProperties &&
                    service.serviceJsonProperties
                      .showGuideOptionalRegistrationsDescription
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{
                    'Show Optional registrations description text' | translate
                  }}</label>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="row cursor-row" (click)="
              service.serviceJsonProperties.showGuideFeesDescription = !service
                .serviceJsonProperties.showGuideFeesDescription; autoSave(guide);
            ">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="showGuideFeesDescription" class="fas {{
                    service.serviceJsonProperties &&
                    service.serviceJsonProperties.showGuideFeesDescription
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{
                    'Show Fees description text' | translate
                  }}</label>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="row cursor-row" (click)="
              service.serviceJsonProperties.requiredDocumentsOpenByDefault = !service
                .serviceJsonProperties.requiredDocumentsOpenByDefault; autoSave(guide);
            ">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="RequiredDocumentsOpenByDefault" class="fas {{
                    service.serviceJsonProperties &&
                    service.serviceJsonProperties
                      .requiredDocumentsOpenByDefault
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{
                    'Required Documents open by default' | translate
                  }}</label>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="row cursor-row" (click)="
              service.serviceJsonProperties.showGuideRequiredDocumentsDescription = !service
                .serviceJsonProperties.showGuideRequiredDocumentsDescription; autoSave(guide);
            ">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="showGuideRequiredDocumentsDescription" class="fas {{
                    service.serviceJsonProperties &&
                    service.serviceJsonProperties
                      .showGuideRequiredDocumentsDescription
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{
                    'Show Required documents description text' | translate
                  }}</label>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="row cursor-row" (click)="
              service.serviceJsonProperties.showGuideConditionsDescription = !service
                .serviceJsonProperties.showGuideConditionsDescription; autoSave(guide);
            ">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="showGuideConditionsDescription" class="fas {{
                    service.serviceJsonProperties &&
                    service.serviceJsonProperties.showGuideConditionsDescription
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{
                    'Show Conditions description text' | translate
                  }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="table-items mt-1" *ngIf="service.serviceJsonProperties && service.serviceJsonProperties.guideType === guideTypesOptions[2]">
            <div class="item">
              <div class="row cursor-row" (click)="shoppingCartActiveClick();">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="shoppingCartActive" class="fas {{
                    service.serviceJsonProperties &&
                    service.serviceJsonProperties.shoppingCartActive
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{
                    'Show shopping cart' | translate
                    }}</label>
                </div>
              </div>
            </div>
            <div class="item" *ngIf="service.serviceJsonProperties.shoppingCartActive">
              <div class="row cursor-row" (click)="activateShoppingCartOnEventClick();">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="activateShoppingCartOnEvent" class="fas {{
                    service.serviceJsonProperties &&
                    service.serviceJsonProperties.activateShoppingCartOnEvent
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{
                    'SC pops up for each new requirement or cost' | translate
                    }}</label>
                </div>
              </div>
            </div>
            <div class="item" *ngIf="service.serviceJsonProperties.shoppingCartActive">
              <div class="row cursor-row" (click)="service.serviceJsonProperties.hideCostIfMissing = !service.serviceJsonProperties.hideCostIfMissing;
              autoSave(guide);">
                <div class="col-auto align-items-center justify-content-start">
                  <em id="hideCostOnSCIfMissing" class="fas {{
                    service.serviceJsonProperties &&
                    service.serviceJsonProperties.hideCostIfMissing
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}"  style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{
                    'Hide costs if missing' | translate
                    }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group" *ngIf="!service.isMyAccountPage">
      <div class="row">
        <div class="col-12">
          <label class="input-label">{{
            'Mule version' | translate
            }}</label>
          <div class="table-items">
            <div class="item">
              <div class="row">
                <div class="col">
                  <select name="service.serviceJsonProperties.muleVersion"
                          [(ngModel)]="service.serviceJsonProperties.muleVersion"
                          (change)="onChange($event, pages)"
                          class="form-control">
                    <option *ngFor="let version of muleVersionOptions" [ngValue]="version">{{muleVersionEnum[version]}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

      <div class="form-group" *ngIf="!service.isMyAccountPage">
          <div class="row">
              <div class="col-12">
                  <label class="input-label">{{
                          'Part B read only form' | translate
                      }}</label>
                  <div class="table-items">
                      <div class="item">
                          <div class="row">
                              <div class="col">
                                  <select name="service.serviceJsonProperties.partBReadOnlyForm"
                                          [(ngModel)]="service.serviceJsonProperties.partBReadOnlyForm"
                                          (change)="onChange($event, pages)"
                                          class="form-control">
                                      <option *ngFor="let opt of partBReadOnlyFormOptions" [ngValue]="opt.value">{{opt.label}}</option>
                                  </select>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>

    <div class="form-group" *ngIf="!service.isMyAccountPage">
      <div class="row">
        <div class="col-12">
          <label class="input-label">{{
            'service.theme' | translate
          }}</label>
          <div class="table-items">
            <div class="item">
              <div class="row">
                <div class="col">
                  <select label=""
                          name="service.serviceJsonProperties.customTheme"
                          [(ngModel)]="service.serviceJsonProperties.customTheme"
                          (change)="onChange($event, publishing)"
                          class="form-control">
                    <option value="default-theme">
                      {{ 'service.defaultTheme' | translate }}
                    </option>
                    <option value="modern-theme">
                      {{ 'service.modernTheme' | translate }}
                    </option>
                    <option value="flat-theme">
                      {{ 'service.flatTheme' | translate }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group" *ngIf="service.isMyAccountPage && systemProperties">
      <div class="row">
        <div class="col-12">
          <label class="input-label">{{ 'Applications list' | translate }}</label>
          <div class="table-items">
            <div class="item" *ngIf="hideApplicationsList">
              <div class="row cursor-row" (click)="hideApplicationsList.enabled = !hideApplicationsList.enabled; updateSystemProperties()">
                <div class="col-auto align-items-center justify-content-start">
                  <em class="fas {{
                    hideApplicationsList.enabled
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{ 'hide_applications_list' | translate }}</label>
                </div>
              </div>
            </div>
            <div class="item" *ngIf="closeApplicationsList">
              <div class="row cursor-row" (click)="closeApplicationsList.enabled = !closeApplicationsList.enabled; updateSystemProperties()">
                <div class="col-auto align-items-center justify-content-start">
                  <em class="fas {{
                    closeApplicationsList.enabled
                      ? 'fa-toggle-large-on toggle-primary'
                      : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                  }}" style="vertical-align: middle;"></em>
                </div>
                <div class="col pl-0">
                  <label>{{ 'close_applications_list' | translate }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
